// extracted by mini-css-extract-plugin
export default {"linkButton":"On4l6M"};